import { render, staticRenderFns } from "./ChangeCaseInfo.vue?vue&type=template&id=86e38ae2&"
import script from "./ChangeCaseInfo.vue?vue&type=script&lang=js&"
export * from "./ChangeCaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./ChangeCaseInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports